import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { CrmOpportunities } from './CrmOpportunities'
import { CrmEventPlanner } from './CrmEventPlanner'

/**
 * SHOWS/EVENTS HUB (Lee, 26 Oct 2026 — menu restructure): Event Planner
 * merges into Shows/Events as a tab — one page for the whole show circuit.
 */
const TABS = [
  { key: 'shows', label: 'Shows/Events' },
  { key: 'planner', label: 'Event Planner' },
]
const STORE = 'wq_shows_hub_tab'

export const CrmShowsHub: React.FC = () => {
  const [sp, setSp] = useSearchParams()
  const [tab, setTab] = useState<string>(() => {
    const fromUrl = sp.get('tab')
    if (fromUrl && TABS.some((t) => t.key === fromUrl)) return fromUrl
    try { const v = localStorage.getItem(STORE); if (v && TABS.some((t) => t.key === v)) return v } catch { /* ignore */ }
    return 'shows'
  })
  useEffect(() => {
    try { localStorage.setItem(STORE, tab) } catch { /* ignore */ }
    if (sp.get('tab') !== tab) { sp.set('tab', tab); setSp(sp, { replace: true }) }
  }, [tab]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="h-full flex flex-col overflow-hidden">
      <div className="shrink-0 flex items-center gap-1 px-4 pt-3 pb-0 bg-surface border-b border-border">
        {TABS.map((t) => (
          <button key={t.key} onClick={() => setTab(t.key)}
            className={`px-3.5 py-2 rounded-t-lg text-[12.5px] font-bold border-b-2 -mb-px transition-colors ${
              tab === t.key ? 'text-brand-700 border-brand-600 bg-surface' : 'text-txt-tertiary border-transparent hover:text-txt-primary'}`}>
            {t.label}
          </button>
        ))}
      </div>
      <div key={tab} className="flex-1 min-h-0 overflow-y-auto animate-fade-in">
        {tab === 'shows' ? <CrmOpportunities /> : <CrmEventPlanner />}
      </div>
    </div>
  )
}

export default CrmShowsHub
